import { CartItem } from '../context/CartContext';
import { formatBRL } from './currency';

export type CheckoutUserInfo = {
  name?: string;
  cep?: string;
};

export function buildWhatsAppMessage(
  items: CartItem[],
  subtotalCents: number,
  user: CheckoutUserInfo,
  siteUrl?: string
) {
  const lines: string[] = [];
  lines.push('Olá! Quero finalizar meu pedido:');
  lines.push('');
  if (items.length === 0) {
    lines.push('(Carrinho vazio)');
  } else {
    items.forEach((i) => {
      const label = [i.productName, i.variantName].filter(Boolean).join(' — ');
      lines.push(`- ${label} x${i.qty} — ${formatBRL(i.unitPriceCents)}`);
      if (i.includes?.length) {
        i.includes.forEach((included) => {
          lines.push(`  • ${included}`);
        });
      }
    });
  }
  lines.push('');
  lines.push(`Subtotal: ${formatBRL(subtotalCents)}`);
  if (user.cep) lines.push(`CEP: ${user.cep}`);
  if (user.name) lines.push(`Nome: ${user.name}`);
  if (siteUrl) lines.push(`Link: ${siteUrl}`);
  return lines.join('\n');
}

export function buildWhatsAppLink(phoneNumber: string, message: string) {
  const clean = phoneNumber.replace(/\D/g, '');
  const base = `https://wa.me/${clean}`;
  const text = encodeURIComponent(message);
  return `${base}?text=${text}`;
}
